<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-12">
                <cph-widget>
                    <h2 slot="header">{{$t('COMMON.prices')}}</h2>
                    <div class="row" slot="body">
                        <div class="col-12">
                            <cph-button @clicked="confirmAction({question: $t('QUESTIONS.deletePrices'), data: {}, callback: removeAllPrices})"
                                        :buttonText="'Remove all'"
                                        :disabled="loadingState"
                                        :classList="'btn btn-danger'">
                            </cph-button>
                        </div>
                        <price-list-item v-for="(price, key) in prices"
                                         class="col-12 col-md-6 col-lg-4 mt-4"
                                         :key="key"
                                         :price="price"
                                         @updated="getPricesAsync"
                                         @remove="confirmAction({question: $t('QUESTIONS.deletePrices'), data: $event, callback: removePrice})"
                                         @editPrice="togglePriceEdition(price)"></price-list-item>
                    </div>
                </cph-widget>
            </div>
            <transition name="fade" mode="out-in">
                <functional-modal @close="editing = false"
                       v-if="editing"
                       key="price-modal"
                       :showModal="editing"
                       :title="$t('UI.edit')">
                    <div :class="['col-12']"
                         slot="body">
                        <price-edition
                            :item="editedPrice"
                            :mode="mode"
                            @cancel="editing = false"
                            @remove="confirmAction({question: $t('QUESTIONS.deletePrice'), data: $event, callback: removePrice})"
                            @updated="getPricesAsync; editing = false"></price-edition>
                    </div>
                </functional-modal>
            </transition>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PriceListItem from '../../../components/Panel/Prices/PriceListItem.vue';
import PriceEdition from '../../../components/Panel/Prices/PriceEdition.vue';
import CphWidget from '../../../components/Shared/CphWidget.vue';
import { PricesPerimeter } from '../../../router/perimeters/pricesPerimeter';
import FunctionalModal from '../../../components/Shared/Modal/FunctionalModal';
import CphButton from '../../../components/Shared/UI/Button/CphButton.vue';

export default {
    name: 'PricesView',
    data () {
        return {
            editing: false,
            mode: 'edition',
            editedPrice: {}
        };
    },
    computed: {
        ...mapGetters({
            prices: 'getAllPrices',
            loadingState: 'getLoadingState'
        })
    },
    perimeters: [
        PricesPerimeter
    ],
    components: {
        FunctionalModal,
        PriceListItem,
        PriceEdition,
        CphWidget,
        CphButton
    },
    methods: {
        ...mapMutations(['updateLoadingState', 'addAlert']),
        ...mapActions([
            'getPricesAsync',
            'deletePriceAsync',
            'confirmAction'
        ]),
        togglePriceEdition (price) {
            this.editedPrice = Object.assign({}, price);
            this.editing = true;
        },
        addPrice () {
            this.mode = 'addition';
            this.togglePriceEdition(null, true);
        },
        async removeAllPrices () {
            const promises = [];
            this.updateLoadingState(true);
            for(let key in this.prices) {
                promises.push(this.deletePriceAsync(this.prices[key].id));
            }
            await this.$utils.resolvePromises(promises);
            this.addAlert({
                title: 'Successfuly ',
                type: 'success',
                body: `removed ${promises.length} prices`
            });
            await this.getPricesAsync();
            this.updateLoadingState(false);
        },
        async removePrice ({id}) {
            this.$emit('updated');
            await this.deletePriceAsync(id);
            await this.getPricesAsync();
            this.$store.commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `deleted price ${id}`
            });
        },
        async fetchData () {
            this.updateLoadingState(true);
            await this.getPricesAsync();
            this.updateLoadingState(false);
        }
    },
    created () {
        this.fetchData();
    }
};
</script>

